<template>
  <v-dialog v-model="visible" persistent max-width="400" overlay-opacity="0.8">
    <v-card class="card-shadow border-radius-xl">
      <v-card-title class="text-center pt-6 pb-2">
        {{ title }}
      </v-card-title>
      <v-card-text class="text-center py-4">
        <p class="text-body-1 text-typo mb-0">
          {{ message }}
        </p>
        <p
          v-if="highlightMessage"
          class="text-body-1 mb-0 info-dialog-highlight"
        >
          {{ highlightMessage }}
        </p>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer></v-spacer>
        <v-btn
          height="43"
          class="
            font-weight-bold
            text-uppercase
            btn-primary
            bg-gradient-primary
            py-2
            px-6
            me-2
            mt-7
            mb-2
            w-100
          "
          color="#5e72e4"
          @click="onYesClick"
        >
          {{ yesButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InfoDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Information",
    },
    message: {
      type: String,
      default: "Operation completed successfully.",
    },
    yesButtonText: {
      type: String,
      default: "OK",
    },
    yesCallback: {
      type: Function,
      default: null,
    },
    highlightMessage: {
      type: String,
      default: "",
    },
  },
  methods: {
    onYesClick() {
      if (this.yesCallback) {
        this.yesCallback();
      }
      this.$emit("update:visible", false);
      this.$emit("yes-clicked");
    },
  },
};
</script>

<style scoped>
.v-card-actions {
  justify-content: flex-end;
}
.text-body-1 {
  white-space: pre-line;
}
.info-dialog-highlight {
  color: #d32f2f;
  font-weight: 700;
  font-size: 1.1rem;
  margin-top: 12px;
  white-space: pre-line;
}
</style>
